export const DAILYUPDATE_ADD="DAILYUPDATE_ADD";
export const DAILYUPDATE_LIST="DAILYUPDATE_LIST";